var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chart-container" }, [
    _c("div", {
      ref: "myChartLine",
      staticClass: "lineChart clearfix",
      attrs: { id: _vm.id },
    }),
    _c("div", {
      attrs: {
        id: _vm.id + "-copy",
        "data-clipboard-text": _vm.id,
        "data-clipboard-action": "copy",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }